<div class="task-custom-field-container">
	<div class="header-wrap">
		<span class="tab" [ngClass]="{ selected: selectedTab === 'management' }" (click)="selectedTab = 'management'; clearInputs(false)">{{
			labels.lbl_campos_customizados_tarefas
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedTab === 'create' }" (click)="selectedTab = 'create'; clearInputs(true)">{{
			labels.lbl_novo_campo_customizado_tarefa
		}}</span>
	</div>
	<div class="body-wrap">
		<ng-container *ngIf="selectedTab === 'management'">
			<div class="form-wrap">
				<pcp-request-classification
					[initOn]="'solutionArea'"
					[isEditingClassification]="classificationOptions.isEditingClassification"
					[alertField]="classificationOptions.alertField"
					[hideField]="classificationOptions.hideField"
					[customerList]="classificationOptions.selectedCustomer"
					[requiredField]="classificationOptions.requiredField"
					(getClassification)="setClassification($event, 'searchClassification')">
				</pcp-request-classification>

				<div class="button-container">
					<div class="button" [ngClass]="{ disabled: isLoadingCustomfields }" (click)="searchCustomfields()">
						{{ labels.lbl_geral_buscar }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isLoadingCustomfields"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</div>

			<cpi-msp-table
				[header]="taskCustomFieldViewItems"
				[body]="taskCustomFieldArr"
				[height]="'33dvh'"
				[labels]="labels"
				[insideSort]="true"
				[tableOnly]="true"
				(getSelectedItem)="selectTaskCustomfield($event)"
				(getSelectedItemIndex)="selectedIndex = $event"
				*ngIf="taskCustomFieldArr.length > 0">
			</cpi-msp-table>
		</ng-container>

		<ng-container *ngIf="selectedTab === 'create'">
			<div *ngFor="let item of taskCustomFieldData; let i = index">
				<pcp-request-classification
					[initOn]="'changeType'"
					[isEditingClassification]="classificationOptions.isEditingClassification"
					[alertField]="classificationOptions.alertField"
					[hideField]="classificationOptions.hideField"
					[customerList]="classificationOptions.selectedCustomer"
					[requiredField]="classificationOptions.requiredField"
					[initialIdServicetype]="selectedClassification?.serviceType?.[0]?.id"
					[initialIdScope]="selectedClassification?.scope?.[0]?.id"
					[initialIdCategory]="selectedClassification?.category?.[0]?.id"
					[initialIdTopic]="selectedClassification?.topic?.[0]?.id"
					[initialIdSolutionArea]="selectedClassification?.solutionArea?.[0]?.id"
					(getClassification)="setClassification($event, 'selectedClassification')">
				</pcp-request-classification>

				<div>
					<cpi-dot-bounce-loading-effect
						class="mt-2 ml-2"
						*ngIf="isLoadingTasks"
						[color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
					<div class="dotted-input-container" *ngIf="!isLoadingTasks && tasks.length > 0">
						<span>{{ labels.lbl_chamado_tarefa }}</span>
						<select id="task" name="task" [(ngModel)]="item.values">
							<option [value]="''" selected>{{ labels.lbl_geral_selecione }}</option>
							<option *ngFor="let task of tasks" [value]="task.id">{{ task.taskId }} - {{ task.task }}</option>
						</select>
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_nome }}</span>
						<input [(ngModel)]="item.name" placeholder="{{ labels.lbl_geral_nome }}" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_tipo_do_campo }}</span>
						<select [(ngModel)]="item.inputType">
							<option [value]="'text'">{{ labels.lbl_geral_texto }}</option>
							<option [value]="'select'">{{ labels.lbl_geral_selecao }}</option>
						</select>
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_mandatory }}</span>
						<cpi-checkbox
							[value]="item.required"
							(oValue)="item.required = $event"
							[innerText]="item.required ? labels.lbl_geral_sim : labels.lbl_geral_nao">
						</cpi-checkbox>
					</div>

					<div *ngIf="item.inputType === 'select'">
						<cpi-generic-form-gen [setGenericForm]="selectItems" [columns]="1" [labels]="labels"> </cpi-generic-form-gen>
					</div>
				</div>
			</div>

			<div class="button-container" *ngIf="selectedCustomfieldClassification.length > 0">
				<div class="button" (click)="selectedTab = 'management'; clearInputs(false)">
					{{ labels.lbl_geral_voltar }}
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: tasks.length === 0 }"
					(click)="
						confirmDeleteField.classList.contains('confirmClick') ? deleteTaskCustomField() : confirmButton(confirmDeleteField)
					"
					#confirmDeleteField>
					{{ labels.lbl_geral_excluir }}
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingTaskCustomfield || tasks.length === 0 }"
					(click)="createTaskCustomField()"
					*ngIf="taskCustomFieldData[0].id == '-1'">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingTaskCustomfield"></cpi-dot-bounce-loading-effect>
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingTaskCustomfield || tasks.length === 0 }"
					(click)="updateTaskCustomField()"
					*ngIf="taskCustomFieldData[0].id != '-1'">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingTaskCustomfield"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</ng-container>
	</div>
</div>
